// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getCustomerAuditEvents } from '@/audit/api/get-customer-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';

interface Props {
  customerKey: string;
}

export function CustomerAuditList(props: Props) {
  const { data } = useSuspenseQuery({
    queryKey: ['customer', props.customerKey, 'audit'],
    queryFn: () => getCustomerAuditEvents(props.customerKey),
    retry: false,
  });

  return (
    <Stack spacing={2}>
      {data.events.map((event) => (
        <AuditEventListItem key={event.id} event={event} />
      ))}
    </Stack>
  );
}
